module.exports = __webpack_public_path__ + "static/img/1.67e7f46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/1.png
// module id = vKvA
// module chunks = 0